function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import defaultPropTypes from './utils/prop-types';
import { onResize, WDHComponent } from '../../../../../wdh-foundation/wdh';
import mainStore from './stores/main';
import ProgressBar from './views/progress-bar';
import StepManager from './views/step-manager';
import defaultSettings from '../default-settings.json';
var $ = jQuery; // eslint-disable-line
/**
 * @memberOf module:wdh-hearing-test
 */
var WDHHearingTest = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHHearingTest() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hearing-test-spot:not(.quiz)';
    _classCallCheck(this, WDHHearingTest);
    _this = _callSuper(this, WDHHearingTest, [className]);
    _this.defaultSettings = defaultSettings;
    return _this;
  }
  _inherits(WDHHearingTest, _WDHComponent);
  return _createClass(WDHHearingTest, [{
    key: "init",
    value: function init(component) {
      var settings = Object.assign({}, this.defaultSettings, this.getSettingsFromComponent(component));
      ReactDOM.render(/*#__PURE__*/React.createElement(AppWithObserver, {
        settings: settings
      }), component.querySelector('.component-content'));
    }

    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};
      try {
        settings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      return settings;
    }
  }]);
}(WDHComponent);
var DGS = window.DGS; // eslint-disable-line
var App = /*#__PURE__*/function (_React$Component) {
  function App(props) {
    var _this2;
    _classCallCheck(this, App);
    _this2 = _callSuper(this, App, [props]);
    _this2.state = {
      mediaData: [],
      isDesktop: App.isDesktop()
    };

    // initialize state with settings
    mainStore.setSteps(props.settings.Steps);
    // eslint-disable-next-line no-unused-expressions
    props.settings.DefaultPoints && mainStore.setDefaultPoints(props.settings.DefaultPoints);
    return _this2;
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      // Preload all background images
      var mediaData = this.props.settings.Steps.reduce(function (media, step) {
        var backgroundImage = step.BackgroundImage;
        if (backgroundImage && media.indexOf(backgroundImage) === -1) {
          media.push(backgroundImage);
        }
        return media;
      }, []);
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mediaData: mediaData
      });
      onResize(function () {
        _this3.setState({
          isDesktop: App.isDesktop()
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      $(window).on('keydown', this.onHandleKeyboardUse);
    }
  }, {
    key: "onHandleKeyboardUse",
    value: function onHandleKeyboardUse(e) {
      if (e.keyCode === 9) {
        $('.hearing-test-container').eq(0).attr('tabindex', '0').focus().attr('tabindex', '-1');
        $(window).off('keydown', this.onHandleKeyboardUse);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        mediaData = _this$state.mediaData,
        isDesktop = _this$state.isDesktop;
      return /*#__PURE__*/React.createElement("div", {
        className: "hearing-test-container"
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        currentStep: mainStore.currentStepIndex + 1,
        totalSteps: mainStore.steps.length,
        steps: mainStore.steps
      }), /*#__PURE__*/React.createElement(StepManager, {
        settings: this.props.settings,
        isDesktop: isDesktop
      }), /*#__PURE__*/React.createElement("div", {
        className: "preload",
        style: {
          display: 'none'
        }
      }, !!mediaData && mediaData.map(function (media, index) {
        return /*#__PURE__*/React.createElement("img", {
          src: media,
          alt: "",
          key: index
        });
      })));
    }
  }], [{
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }
  }]);
}(React.Component);
App.propTypes = {
  settings: defaultPropTypes.settings.isRequired
};
var AppWithObserver = observer(App);
export default WDHHearingTest;